"use strict";
const config = require('../../../../../config/locales_json/packs/private/admin/wizard_form_client.json');
const language = $('body').data("language");

// Class definition
var KTWizardClient = function () {
	// Base elements
	var _wizardEl;
	//var _formEl;
	var _wizard;
	//var _validations = [];

	// Private functions
	var initWizard = function () {
		var isNew = $(".new-client-container").length > 0 ? true : false

		// Initialize form wizard
		_wizard = new KTWizard(_wizardEl, {
			startStep: 1, // initial active step number
			clickableSteps: (isNew ? false : true) // to make steps clickable this set value true and add data-wizard-clickable="true" in HTML for class="wizard" element
		});

		// Validation before going to next page
		_wizard.on('beforeNext', function (wizard) {
			// Don't go to the next step yet
			_wizard.stop();

			//render_review_form()
			//_wizard.goNext();

			var actualStep = $(wizard)[0]["currentStep"]
			// Formulario de crear cliente
			if(actualStep == 1){
				//_wizard.goNext();

				// Se validan los campos
				var formOfert = check_inputs_form("client-step-1");

				if(!formOfert){
					const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "formOfert_error_text"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.");
					error_alert(errorText)
				} else {
					render_review_form()
					_wizard.goNext();
				}

			// Asignación de areas
			} else if(actualStep == 2){
				//_wizard.goNext();

				// Revisa si ha sido checkeado algun elemento
				var isChecked = $('#client-step-2 .category-client-item:checked').length;
				// Si no esta chequeado
				if (isChecked == 0) {
					const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "actualStep_2_error_text"], "Debes seleccionar al menos una opción.");
					error_alert(errorText)
				} else {
					render_review_form()
					_wizard.goNext();
				}
			} else if(actualStep == 3){

				// Se validan los campos
				var formClientProfile = check_inputs_form("client-step-3");

				if(!formClientProfile){
					const errorText = getTranslationValue(config, [language, "KTWizardClient", "initWizard", "formOfert_error_text"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.");
					error_alert(errorText)
				} else {
					render_review_form()
					_wizard.goNext();
				}
			}
		});

		// Change event
		_wizard.on('change', function (wizard) {
			KTUtil.scrollTop();
		});
	}

	var check_inputs_form = function (form) {
		var error = 0;
		var container = $('#'+form+'');
		var inputs = container.find($("input").not(".optional"));
		var selects = container.find($("select").not(".optional"));
		var textareas = container.find($("textarea").not(".optional"));

		const errorMsgText = getTranslationValue(config, [language, "KTWizardClient", "check_inputs_form", "errorMsgText"], "Debes completar este campo.");
		const errorWithoutOptionsText = getTranslationValue(config, [language, "KTWizardClient", "check_inputs_form", "errorWithoutOptionsText"], "Debes agregar al menos una opción.");

		var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorMsgText+'</div></div>';
		var errorWithoutOptions = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorWithoutOptionsText+'</div></div>';

		inputs.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "" && typeof inputName != "undefined") {
				if (inputType == "radio" || inputType == "checkbox") {
					inputName = $(this).attr('name');
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Validamos si este input esta dentro de un checkbox list
					if(contInput.hasClass("checkbox-list")){
						// Cambia el contInput
						contInput = $(this).parent().parent().parent();
					}

					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Revisa si esta activada la opcion
					var isChecked = $('input[name="'+ inputName +'"]:checked').length;
					// Si no esta chequeado
					if (isChecked == 0) {
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						contInput.find(".fv-plugins-message-container").remove()
					}
				} else if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.find(".fv-plugins-icon-container").append(errorMsg);
							// Le suma al contador de errores
							error++;
						// Si el input esta correcto
						} else {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-success");
						}
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							$(this).addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.append(errorMsg);
							// Le suma al contador de errores
							error++;
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}
					}

				} else if (inputType == "file") {
					// Remueve el icono de alerta o success del input
					$(this).removeClass("is-invalid");
					$(this).removeClass("is-valid");
					// Cambia el contInput
					contInput = $(this).parent().parent().parent();
					// Remueve la clase de has-danger y has-success al contenedor del input
					contInput.removeClass("has-danger");
					contInput.removeClass("has-success");
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Si el input esta vacio
					if (!$(this).val()) {
						// Agrega el icono al input
						$(this).addClass("is-invalid");
						// Agrega la clase de has-danger al contenedor del input
						contInput.addClass("has-danger");
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		selects.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si el input esta vacio
				if ($(this).val().length == 0) {
					// Si es multiple
					if(hasMultiple) {
						// Al input con la clase tt-input le va a agregar la clase form-control para que muestre
						// el icono
						$(this).parent().find(".tt-input").addClass("form-control");
						// Cambia el icono de invalido por valido
						$(this).parent().find(".tt-input").removeClass("is-valid").addClass("is-invalid");
					}

					// Si es selectized
					if(hasSelectized) {
						// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
						// cambie el icono de valido por invalido
						$(this).parent().find(".selectize-control").removeClass("is-valid").addClass("is-invalid");
					}

					$(this).addClass("is-invalid");
					contInput.addClass("has-danger");
					contInput.append(errorMsg);
					error++;
				} else {
					// Debemos validar el formulario de preguntas para las preguntas con opciones.
					// Asi que primero detectamos que select es una preguna del formulario
					var hasQuestionSelect = $(this).hasClass("filter_question_enum_type")
					// Si es un select del formulario de preguntas
					if(hasQuestionSelect) {
						// Si la pregunta es de los tipo con opciones
						if ($(this).val() == "2" || $(this).val() == "3" || $(this).val() == "4") {
							// Obtiene las opciones que hay
							var optionsQuestion = $(this).parent().parent().parent().find(".cont-option-question-filter").children()
							// Si hay opciones se valida correctamente
							if(optionsQuestion.length > 0){
								// Agrega el icono al input
								$(this).addClass("is-valid");
								// Agrega la clase de has-success al contenedor del input
								contInput.addClass("has-success");
							// Si no tiene opciones
							} else {
								$(this).addClass("is-invalid");
								contInput.addClass("has-danger");
								contInput.append(errorWithoutOptions);
								error++;
							}
						// Si la pregunta es de un tipo texto
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}

					// De lo contrario es un select normal y se valida correctamente
					} else {
						// Si es multiple
						if(hasMultiple) {
							// Cambia el icono de invalido por valido
							$(this).parent().find(".tt-input").removeClass("is-invalid").addClass("is-valid");
						}

						// Si es selectized
						if(hasSelectized) {
							// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
							// cambie el icono de valido por invalido
							$(this).parent().find(".selectize-control").removeClass("is-invalid").addClass("is-valid");
						}

						// Agrega el icono al input
						$(this).removeClass("is-invalid").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		textareas.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Si el input esta vacio
				if (!$(this).val()) {
					// Agrega el icono al input
					$(this).addClass("is-invalid");
					// Agrega la clase de has-danger al contenedor del input
					contInput.addClass("has-danger");
					// Muestra el mensaje de error
					contInput.append(errorMsg);
					error++;
				} else {
					// Agrega el icono al input
					$(this).addClass("is-valid");
					// Agrega la clase de has-success al contenedor del input
					contInput.addClass("has-success");
				}
			}
		})

		// Se coloca el simbolo de ok a los campos que no son obligatorios
		var inputsNotOptional = container.find($("input.optional"));
		var selectsNotOptional = container.find($("select.optional"));
		var textareasNotOptional = container.find($("textarea.optional"));

		inputsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Agrega el icono al input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.find(".fv-plugins-icon-container").addClass("has-success");
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				} else if (inputType == "checkbox") {
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
				}
			}
		})

		selectsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si es multiple
				if(hasMultiple) {
					// Cambia el icono de invalido por valido
					$(this).parent().find(".tt-input").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}
				// Si es selectized
				if(hasSelectized) {
					// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
					// cambie el icono de valido por invalido
					$(this).parent().find(".selectize-control").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}

				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		textareasNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		return error == 0 ? true : false;
	}

	var render_review_form = function() {
		// Esto es del primer paso del wizard
		// Asigna la infromacion a las variables
		var logo = $("#client-form #cont_form_client_logo .image-input-wrapper").attr("style")
		var company = $("#client-form #client_company option:selected").text()
		var clientName = $("#client-form #client_name").val()
		var anonymousName = $("#client-form #client_anonymous_name").val()
		var country = $("#client-form #client_country").val()
		var website = $("#client-form #client_website").val()

		// Reemplaza la información que existan en los elementos por el de la variable
		$("#client-form #item_logo .image-input-wrapper").attr("style", logo)
		$("#client-form #item_company span").text(company)
		$("#client-form #item_name span").text(clientName)
		$("#client-form #item_anonymous_name span").text(anonymousName)
		$("#client-form #item_country span").text(country)
		$("#client-form #item_website span").text(website)

		// Se limpia el listado de areas
		$("#client-form .cont-category-clients").html('');
		// Revisa si ha sido checkeado algun elemento
		var categorySelected = $('#client-step-2 .category-client-item:checked');
		if (categorySelected.length > 0) {
			var listClientCategories = ""
			$.each(categorySelected, function(i, category) {
				// Se obtiene el texto del label
				var categoryName = $(category).parent().text()
				// Se limpian los espacios del string
				categoryName = $.trim(categoryName)
				// Se asigna el elemento a renderear
				var outputList = "<li>"+categoryName+"</li>";
				// Se agrega el nuevo elemento en el listado
				listClientCategories = listClientCategories + outputList
			});

			var output = '<div class="row container cont-review-options"><div class="col-sm-12"><ul class="mt-5">'+listClientCategories+'</ul></div></div></div>';

			$("#client-form .cont-category-clients").append(output)
		}

		// Preview Perfil Empresa
		if ($("#client-form #client-step-3").length > 0) {
			var bannerStyle = $("#client-form #cont_form_client_profile_banner .image-input-wrapper").attr("style")
			var showNCollaborators = $("#client-form #cp_overview_collaborators").parent().find(".overview-is-active").is(':checked')
			var showLocation = $("#client-form #cp_overview_location").parent().find(".overview-is-active").is(':checked')
			var aboutCompany = $.parseHTML($("#client-form #cp_about_us").val())

			$("#client-form #item_banner .image-input-wrapper").attr("style", bannerStyle);
			
			if (showNCollaborators) {
				$("#client-form #item_n_collaborators").removeClass("d-none");
				$("#client-form #item_n_collaborators span").text($("#client-form #cp_overview_collaborators").val())
			} else {
				$("#client-form #item_n_collaborators").addClass("d-none");
				$("#client-form #item_n_collaborators span").text("")
			}

			if (showLocation) {
				$("#client-form #item_overview_location").removeClass("d-none");
				$("#client-form #item_overview_location span").text($("#client-form #cp_overview_location").val())
			} else {
				$("#client-form #item_overview_location").addClass("d-none");
				$("#client-form #item_overview_location span").text("")
			}

			$("#client-form #item_about_us span").html(aboutCompany)

			if ($("#client_profile_ranking").length > 0 && !$("#client_profile_ranking").parent().hasClass('disabled')) {
				var showRanking = $("#client-form #client_profile_ranking_input").is(':checked');
				const showRankingTranslation = { "es": "Sí", "en": "Yes", "pt": "Sim" };
				
				if (showRanking) {
					$("#client-form #item_cp_ranking").removeClass("d-none")
					$("#client-form #item_cp_ranking span").text(showRankingTranslation[language])	
				} else {
					$("#client-form #item_cp_ranking").addClass("d-none")
					$("#client-form #item_cp_ranking span").text("")	
				}
			}
		}
	}

	var error_alert = function(msg) {
		Swal.fire({
			text: msg,
			icon: "error",
			buttonsStyling: false,
			confirmButtonText: getTranslationValue(config, [language, "KTWizardClient", "error_alert", "swalfire_confirmButtonText"], "Aceptar"),
			customClass: {
				confirmButton: "btn btn-fj-purple"
			}
		}).then(function () {
			KTUtil.scrollTop();
		});
	}

	return {
		// public functions
		init: function () {
			_wizardEl = KTUtil.getById('kt_wizard_client');
			//_formEl = KTUtil.getById('kt_form');

			// Se obtiene el campo kt_wizard_client
			var wizardClient = $('#kt_wizard_client')
			// Si existe el campo
			if (wizardClient.length > 0) {
				initWizard();
			}
		}
	};
}();

jQuery(document).ready(function () {
	KTWizardClient.init();

	/*************
    * CREAR / EDITAR CLIENTE
    *
    * - Logica de activacion de campo pais como autocompletar (typeahead)
    * - Validacion y ejecución del formulario
    */
  	// Se obtiene el campo ofert_city
  	var clientCountry = $('#kt_wizard_client #client-form #client_country')
  	// Si existe el campo
  	if (clientCountry.length > 0) {
		// Inicializa los países
		var countries = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('nicename'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			sufficient: 10,
			remote: {
				url: '/settings/countries/%QUERY',
				wildcard: '%QUERY',
				filter: function(list) {
				return $.map(list.data, function(item) {
					return { id: item.id, nicename: item.nicename }
				});
				}
			}
		});

		clientCountry.typeahead(
			{
				hint: false,
				highlight: true,
				minLength: 3
			},
			{
				name: 'countries',
				display: 'nicename',
				source: countries,
				limit: 10
			}
		)

		// Si el campo esta vacio limpia el hidden
		clientCountry.on("input", function() {
			// Limpia el campo hidden
			$("#client_hidden_country_id").val(null);
		});

		// Si sale del campo y esta vacio
		clientCountry.focusout(function(){
			// Obtengo el valor del input
			var dInput = this.value;
			// Si el input esta vacio
			if(dInput.length == 0){
			  	// Limpia el campo hidden
				$("#client_hidden_country_id").val(null);
			}
		});

		// Cuando se selecciona una opcion del listado del autocompletar se ejecuta esto
		clientCountry.bind('typeahead:select', function(ev, el) {
			// Obtiene el id del pais y lo guarda en el input hidden que se genera
			$("#kt_wizard_client #client_hidden_country_id").val(el.id);
		});
	}

	// Se aplica selectize en el campo compañia
	$('#client_company').selectize({
		create: true,
		render: {
			option_create: function(query) {
				var listOptions = $("#cont_form_company_name .selectize-dropdown-content").find(".option")

				if(listOptions.length > 0){
					var classHidden = "hidden"
				} else {
					var classHidden = ""
				}

				return '<div class="create '+classHidden+'">Agregar <strong>'+query.input+'</strong>…</div>';
			}
		}
	})

	// Envio de creacion/edicion de clientes
	var clientForm = $("#kt_wizard_client #client-form")
	clientForm.on("click", ".action-submit", function(e){
		const disabledText = getTranslationValue(config, [language, "clientForm_on_click_action_sumit"], "Enviando Información...")
		$(this).addClass("disabled").text(disabledText);
		clientForm.addClass("disabled")
		clientForm.submit();
	})
	/*************
  	* FIN CREAR / EDITAR OFERTA
  	*/
	
	$('#client-form').on("change", "input[type='checkbox'].overview-is-active", function () {
		var inputContent = $(this).parent().parent().find('input.overview-content');
		if ($(this).is(':checked')) {
			inputContent.removeAttr('disabled');
			inputContent.removeClass('optional disabled');
		} else {
			inputContent.val('');
			inputContent.attr('disabled', true);
			inputContent.addClass('optional disabled');
		}
	})

	$('#client-form').on("change", "input[type='checkbox'].overview-is-active", function () {
		var inputContent = $(this).parent().parent().find('input.overview-content');
		if ($(this).is(':checked')) {
			inputContent.removeAttr('disabled');
			inputContent.removeClass('optional disabled');
		} else {
			inputContent.val('');
			inputContent.attr('disabled', true);
			inputContent.addClass('optional disabled');
		}
	})
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}